import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Profile from "@/pages/Profile";
import AuthCallback from "@/pages/AuthCallback";
import ReceiptView from "@/pages/ReceiptView";
import WelcomeOffer from "@/components/site/WelcomeOffer";
import WrongSiteBanner from "@/components/site/WrongSiteBanner";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider } from "@/contexts/AuthContext";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <AuthProvider>
            <WrongSiteBanner />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/receipts/:token" element={<ReceiptView />} />
            </Routes>
            <WelcomeOffer />
          </AuthProvider>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </I18nProvider>
    </div>
  );
}

export default App;
